import { createMuiTheme } from "@material-ui/core/styles";

export const blueTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#3490ce"
    },
    secondary: {
      main: "#435a7e"
    }
  }
});
